import { SearchOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Input, PageHeader, Row, Select } from 'antd'
import React, { useEffect, useState } from 'react'

import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from '../../utility/Constants'
import commonUtility from "../../utility/Utils";
import SecurityDepositView from "../../components/report/SecurityDepositView";
import CustomTableSearch from "../../components/common/CustomTableSearch";
import { PRINT_BASE_URL } from "../../utility/URL";
const { Option } = Select;


const defaultFormValues = {
    receipt_start_date: commonUtility.firstDateOfMonth(),
    receipt_end_date: commonUtility.lastDateOfMonth(),
};

const SecurityDepositList = () => {
    const [form] = Form.useForm();
    const [programmeList, setProgrammeList] = useState([]);
    const [reportList, setReportList] = useState([]);
    const [filteredSearchList, setFilteredSearchList] = useState([]);

    const onFromDateChange = (date, dateString) => {
        form.setFieldsValue({
            receipt_start_date: dateString
        });
    };

    const onEndDateChange = (date, dateString) => {
        form.setFieldsValue({
            receipt_end_date: dateString
        });
    };



    const onReportSearch = async (values) => {
        setReportList([])
        setFilteredSearchList([]);

        const formdValues = {
            programme_id: values.programme_id == undefined ? '' : values.programme_id,
            from_date: values.receipt_start_date == undefined ? '' : values.receipt_start_date,
            to_date: values.receipt_end_date == undefined ? '' : values.receipt_end_date,
        }

        const data = { formdata: formdValues };

        ProgrammeService.allSecurityDeposit(data).then((res) => {
            if (res.data.response_status == SUCCESS_STATUS) {
                setReportList(res.data.response_data);
                setFilteredSearchList(res.data.response_data);
            }
            else {
                setReportList([])
                setFilteredSearchList([]);
            }
        });
    };


    useEffect(() => {
        ProgrammeService.programmeList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeList(res.data.response_data);
            }
        });
    }, []);

    const onSearch = (e) => {
        const string = e.target.value;
        if (string === '') {
            setFilteredSearchList(reportList);
        } else {
            const filtered = reportList.filter((data) => 
                Object.values(data).join('').replace(/\s/g, '').toLowerCase().includes(string.replace(/(\s+|to)/g, '').toLowerCase())
            );
            setFilteredSearchList(filtered);
        }
    }

    const handleExcelAllReceipt = async () => {
        try {
            const values = await form.validateFields();
            const url_excel = 'member/security_deposit_excel';
            let url = buildExcelUrl(values, url_excel);
            commonUtility.openInNewTab(url);
        } catch (error) {
            console.error('Error generating Excel report:', error);
        }
    };

    const formatDate = (dateStr) => {
        return dateStr ? dateStr.replace(/\//g, '-') : '';
    };

    const buildExcelUrl = (values, url_first) => {
        let url = '';
        const formValues = {
            from_date: formatDate(values.receipt_start_date) || '',
            to_date: formatDate(values.receipt_end_date) || '', 
            programme_id: values.programme_id || '0',
        };

        if (formValues.from_date !== "" && formValues.from_date !== "") {
            url = `${PRINT_BASE_URL}${url_first}/${formValues.from_date}/${formValues.to_date}/${formValues.programme_id}`;
        }

        return url;
    };

    const handlePDFAllReceipt = async () => {
        try {
            const values = await form.validateFields();
            const url_excel = 'member/security_deposit';
            let url = buildPDFUrl(values, url_excel);
            commonUtility.openInNewTab(url);
        } catch (error) {
            console.error('Error generating Excel report:', error);
        }
    };

    const buildPDFUrl = (values, url_first) => {
        let url = '';
        const formValues = {
            from_date: formatDate(values.receipt_start_date) || '',
            to_date: formatDate(values.receipt_end_date) || '', 
            programme_id: values.programme_id || '0',
        };

        if (formValues.from_date !== "" && formValues.from_date !== "") {
            url = `${PRINT_BASE_URL}${url_first}/${formValues.from_date}/${formValues.to_date}/${formValues.programme_id}`;
        }
        return url;
    };

    

    return (
        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />
                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Security Deposit List"
                        subTitle=""

                    ></PageHeader>
                    <div className="">
                        <Row className="" style={{ background: "rgb(249, 249, 249)" }}>
                            <Col className="" xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onReportSearch}
                                    autoComplete="off"
                                    initialValues={defaultFormValues}
                                >

                                    <Row gutter={10} >


                                        <Col xs={24} xl={3} >

                                            <Form.Item name="from_date_picker" label="From Date">
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_SLASH}
                                                    onChange={onFromDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}

                                                />
                                            </Form.Item>
                                            <Form.Item name="receipt_start_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={3} >

                                            <Form.Item name="to_date_picker" label="End Date" >
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_SLASH}
                                                    onChange={onEndDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                />
                                            </Form.Item>
                                            <Form.Item name="receipt_end_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>

                                        </Col>

                                        <Col xs={4} xl={6}>
                                            <Form.Item
                                                name="programme_id"
                                                label="Programme"

                                            >
                                                <Select className="text-left">
                                                    <Option value="">Select</Option>
                                                    {programmeList.length > 0
                                                        ? programmeList.map((programme_list) => (
                                                            <Option
                                                                key={programme_list.programme_id}
                                                                value={programme_list.programme_id}
                                                                short_code={programme_list.short_code}
                                                            >
                                                                {programme_list.programme_name}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={1}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="submit"
                                                    shape="round"
                                                    className="custom-button-green"
                                                    style={{ marginRight: '8px' }}
                                                >
                                                    <SearchOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={1} style={{ marginLeft: '10px' }}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="button"
                                                    shape="round"
                                                    className="custom-button-green"
                                                    onClick={handleExcelAllReceipt}
                                                >
                                                    Excel
                                                </Button>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={1} style={{ marginLeft: '30px' }}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="button"
                                                    shape="round"
                                                    className="custom-button-green"
                                                    onClick={handlePDFAllReceipt}
                                                >
                                                    PDF
                                                </Button>
                                            </Form.Item>
                                        </Col>


                                    </Row>
                                </Form>
                            </Col>
                        </Row>

                        <div className='tableView'>
                            <CustomTableSearch onSearchTable={onSearch} style={{ marginBottom: "8px" }} />
                            <div className="form-content">
                                <SecurityDepositView securityDepositList={filteredSearchList} />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>


    )
}

export default SecurityDepositList